export default __webpack_public_path__ + "static/media/hht2_storybook_13.f758fa50.png";